import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import LoadingView from "./components/loading-view";
import { Sentry } from "./utils/sentry";
import { useUser } from "@clerk/clerk-react";
import { usePostHog } from "posthog-js/react";

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

const NotFoundPage = lazy(() => import("./pages/not-found"));
const HomePage = lazy(() => import("./pages/home"));
const CreatePage = lazy(() => import("./pages/create"));
const AgentDetailsPage = lazy(() => import("./pages/agents/[id]/page"));
const TrainingTab = lazy(() => import("./pages/agents/[id]/training"));
const AgentTab = lazy(() => import("./pages/agents/[id]/agent"));
const MenuTab = lazy(() => import("./pages/agents/[id]/menu"));
const AdminTab = lazy(() => import("./pages/agents/[id]/admin"));

const LoadingFallback = () => <LoadingView />;

const App = () => {
  const { isSignedIn, user } = useUser();
  const posthog = usePostHog();

  // posthog identify
  useEffect(() => {
    if (isSignedIn && user) {
      posthog.identify(user.id, {
        email: user.emailAddresses[0]?.emailAddress,
      });
    }
    // reset on logout, on auth layout unmount
    return () => {
      posthog.reset();
    };
  }, [isSignedIn, user, posthog]);

  return (
    <Router>
      <Suspense fallback={<LoadingFallback />}>
        <SentryRoutes>
          <Route path="/" element={<HomePage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/:id" element={<AgentDetailsPage />}>
            <Route index element={<Navigate to="menu" replace />} />
            <Route path="agent" element={<AgentTab />} />
            <Route path="menu" element={<MenuTab />} />
            <Route path="training" element={<TrainingTab />} />
            <Route path="admin" element={<AdminTab />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </SentryRoutes>
      </Suspense>
    </Router>
  );
};

export default App;
